import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { loadingFade } from '../../animacoes';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';

import { UsuarioService } from '../services/usuario.service';
import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ProfissionalService } from '../services/profissional.service';
import { VeiculoService } from '../services/veiculo.service';
import { CheckCalibragemService } from '../services/check-calibragem.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-calibragem-pneus-edit',
  templateUrl: './calibragem-pneus-edit.component.html',
  styleUrls: ['./calibragem-pneus-edit.component.css'],
	animations: [loadingFade]
})
export class CalibragemPneusEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public inicioPeriodo;

	public formChecklist: FormGroup;

  public agencias = [];
  public unidades = [];
  public profissionais = [];
  public veiculos = [];

  public check_calibragem_id = null;
  public profissional = null;

  // datepickers
	private data_checklist_dp;

  //filtro
  public cliente_id___cliente = null;
  public unidade_id___unidade = null;
  public veiculo_id___veiculo = null;
  public check_calibragem_turno___periodo = null;
  public check_calibragem_status___status = null;
  public check_calibragem_data___data_i = null;
  public check_calibragem_data___data_f = null;
  public profissional_id___profissional = null;


  constructor(private authSvc: AuthService,
    private usuarioSvc: UsuarioService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private clienteSvc: ClienteService,
    private unidadeSvc: UnidadeService,
    private profissionalSvc: ProfissionalService ,
    private veiculoSvc: VeiculoService,
    private checkcalibragemSvc: CheckCalibragemService) { }

  ngOnInit() {
    this.pegaAgencias();
    //this.pegaProfissionais();
    this.criaForm();
    this.verificaCliente();
    this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {


        var splitFiltro = params.id.split("?");

        if(splitFiltro[1] !== undefined){
          
          var splitfiltro = splitFiltro[1].split("&");
          for (let f in splitfiltro) {

            var loSplitValor = splitfiltro[f].split("=");

            switch(loSplitValor[0]) { 
              case "cliente_id___cliente": { 
                 this.cliente_id___cliente = loSplitValor[1];
                 break; 
              } 
              case "unidade_id___unidade": { 
                this.unidade_id___unidade = loSplitValor[1];
                 break; 
              } 
              case "veiculo_id___veiculo": { 
                this.veiculo_id___veiculo = loSplitValor[1];
                 break; 
              } 
              case "check_calibragem_turno___periodo": { 
                this.check_calibragem_turno___periodo = loSplitValor[1];
                 break; 
              }     
              case "check_calibragem_data___data_i": { 
                this.check_calibragem_data___data_i = loSplitValor[1];
                 break; 
              }      
              case "check_calibragem_data___data_f": { 
                this.check_calibragem_data___data_f = loSplitValor[1];
                 break; 
              }      
              case "profissional_id___profissional": { 
                this.profissional_id___profissional = loSplitValor[1];
                 break; 
              }                                                            
           }

          }


        }  

				this.check_calibragem_id = params.id;
				this.checkcalibragemSvc.getCheckCalibragem(params.id).then((data: any) => {
          this.pegaUnidadesByAgencia(data.cliente_id);
          this.pegaVeiculosByUnidade(data.unidade_id);
          this.pegaVeiculoUnidadeProfissional(data);
					this.preencheForm({
            check_calibragem_id:  data.check_calibragem_id,
            usuario_id:  data.usuario_id,
            check_calibragem_data:  moment(data.check_calibragem_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            check_calibragem_turno:  data.check_calibragem_turno,
            cliente_id:  data.cliente_id,
            unidade_id:  data.unidade_id,
            profissional_id:  data.profissional_id,
            veiculo_id:  data.veiculo_id,
            check_calibragem_ed_pressao: data.check_calibragem_ed_pressao,
            check_calibragem_ed_dot: data.check_calibragem_ed_dot,
            check_calibragem_et_pressao: data.check_calibragem_et_pressao,
            check_calibragem_et_dot: data.check_calibragem_et_dot,
            check_calibragem_dd_pressao: data.check_calibragem_dd_pressao,
            check_calibragem_dd_dot: data.check_calibragem_dd_dot,
            check_calibragem_dt_pressao: data.check_calibragem_dt_pressao,
            check_calibragem_dt_dot: data.check_calibragem_dt_dot,
            
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
    });
  }
  criaForm(){
    
    this.formChecklist = this.fb.group({
			check_calibragem_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
      check_calibragem_data: [moment().format('DD/MM/YYYY'), Validators.required],
      check_calibragem_turno: [this.pegaPeriodo(), Validators.required],
      cliente_id: [null, Validators.required],
      unidade_id: [null, Validators.required],
      profissional_id: [this.profissional, Validators.required],
      veiculo_id: [null, Validators.required],
      check_calibragem_ed_pressao: null,
      check_calibragem_ed_dot: [null, [Validators.required, maxPsi]],
      check_calibragem_et_pressao: null,
      check_calibragem_et_dot: [null, [Validators.required, maxPsi]],
      check_calibragem_dd_pressao: null,
      check_calibragem_dd_dot: [null, [Validators.required, maxPsi]],
      check_calibragem_dt_pressao: null,
      check_calibragem_dt_dot: [null, [Validators.required, maxPsi]],
    });
    
    moment.locale('pt-Br');
    this.data_checklist_dp = Datepicker('#check_calibragem_data', {
			customMonths: moment.months(),
			customDays: moment.weekdaysShort(),
			overlayPlaceholder: 'Preencha o ano',
			overlayButton: 'Enviar',
			formatter: (element, date) => {
				let formatted = moment(date).format('DD/MM/YYYY');
				this.formChecklist.controls['check_calibragem_data'].setValue(formatted);
			}
    });

    if(this.authSvc.getPerfil() != 2){
      this.usuarioSvc.getUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
        this.profissional = data.profissional_id;
        this.formChecklist.get('profissional_id').setValue(data.profissional_id);
        this.formChecklist.get('profissional_id').updateValueAndValidity();
        this.formChecklist.get('profissional_id').disable();
      });
    }
  }

  preencheForm(dados) {
		this.formChecklist.setValue(dados);
  }
  
  pegaPeriodo(){
    let hora = parseInt(moment().format('HH'));
    if(hora > 7  &&  hora < 19){
      return 'D';
    }
    else{
      return 'N';
    }
  }

  pegaAgencias(){
    this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.agencias = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaUnidadesByAgencia(agencia_id){
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), agencia_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }
  
  pegaVeiculosByUnidade(unidade_id){
    this.veiculoSvc.getByTipoVeiculo(unidade_id, 1).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  onChangeAgencia(e){
    this.formChecklist.controls.unidade_id.setValue(null);
    this.formChecklist.controls.veiculo_id.setValue(null);
    this.verificaCliente();
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeUnidade(e){
    this.veiculoSvc.getByTipoVeiculo(e.unidade_id, 1).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  pegaProfissionais(){
    this.profissionalSvc.getProfissionais().then((data: any[]) => {
			this.profissionais = data;
		}).catch((err) => {
			console.log(err);
		});
  }
  
  invalid(nome) {
    let input = this.formChecklist.get(nome);
		return input.touched && input.invalid;
  }
  
  verificaCliente() {
		if (this.formChecklist.get('cliente_id').value)
			this.formChecklist.get('unidade_id').enable();
		else
			this.formChecklist.get('unidade_id').disable();
	}
  
  enviaChecklist() {
    
    if (this.formChecklist.valid) {
      this.submitting = true;
      this.formChecklist.get('profissional_id').enable();
      let toSend = this.formChecklist.value;
      
      if (this.check_calibragem_id === null) { // criar
        toSend.check_calibragem_registro = moment().format('YYYY-MM-DD HH:mm:ss');

				this.checkcalibragemSvc.criaCheckCalibragem(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Checklist cadastrado com sucesso!',
            onClose: ()=>{
          		this.router.navigate(['home/calibragempneus']);
            }
          });
				}).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
				});
			}
			else { // editar
				this.checkcalibragemSvc.editaCheckCalibragem(toSend).then((data) => {
          console.log('resp', data);
				  Swal.fire({
            type: 'success',
            title: 'Checklist alterado com sucesso!',
            onClose: ()=>{
          		this.router.navigate(['home/calibragempneus']);
            }
          });
				}).catch(err => {
					console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
				});
			}
    }
    else{
      Swal.fire({
        type: 'error',
        title: 'Checklist incompleto!',
        text: 'Verifique os itens em vermelho!'
      });
      for( let field in this.formChecklist.controls){
        let campo = this.formChecklist.get(field);
        campo.markAsTouched();
      }
    }
  }

  onChangeRadio(nome) {

    let inputRadio = this.formChecklist.get(nome);
    let inputObs = this.formChecklist.get(nome + '_obs');

    if (inputRadio.value === 'N') {
      inputObs.setValidators(Validators.required);
      inputObs.updateValueAndValidity();
      inputObs.markAsTouched();
      inputObs.invalid;
    } else {
      inputObs.clearValidators();
      inputObs.updateValueAndValidity();
    }
  }

  validaCalibragem(nome){
    let input = this.formChecklist.get(nome).value;
    if(parseInt(input) > 55){
      this.formChecklist.get(nome).invalid;
      Swal.fire({
        type : 'warning',
        title: 'Atenção',
        text : 'Pressão superior à 55 PSI' 
      });
    }
  }

  
  onChangeVeiculoUnidade(e){
    this.pegaVeiculoUnidadeProfissional(e);
	}

  pegaVeiculoUnidadeProfissional(e){
		  
      this.formChecklist.controls.veiculo_id.setValue(null);
      this.formChecklist.controls.profissional_id.setValue(null);
      this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(e.unidade_id,"todos").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: e.unidade_id,
				cliente_id: e.cliente_id
			  });
			}


			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidade(e)
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
  }

  pegaProfissionaisClienteUnidade(e){
		this.loading = true;
		
		this.profissionalSvc.getProfissionalEdit(e.cliente_id,e.unidade_id).then((data: any[]) => {
				this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	  }	

    onClickVoltar(){

      let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
      params += "&unidade_id___unidade=" + this.unidade_id___unidade;
      params += "&veiculo_id___veiculo=" + this.veiculo_id___veiculo;
      params += "&check_calibragem_turno___periodo=" + this.check_calibragem_turno___periodo;
      params += "&check_calibragem_data___data_i=" + this.check_calibragem_data___data_i;
      params += "&check_calibragem_data___data_f=" + this.check_calibragem_data___data_f;
      params += "&profissional_id___profissional=" + this.profissional_id___profissional;
  
      this.router.navigate(['/home/calibragempneusfiltro/' + params]);
  
    }

}

//de fora
function maxPsi(control : AbstractControl): {[key: string]: any} | null{
  const psi: string = control.value;
  if(parseInt(psi) <= 55){
    return null;
  }
  else{
    return {'maxPsi': true};
  }
 
  
  
}